// extracted by mini-css-extract-plugin
export var nav_container = "Navbar-module--nav_container--sz6I1";
export var wrapper = "Navbar-module--wrapper--ct04S";
export var left_section = "Navbar-module--left_section--Z4ibQ";
export var right_section = "Navbar-module--right_section--1uhSJ";
export var dropdown = "Navbar-module--dropdown--m7lDw";
export var dropbtn = "Navbar-module--dropbtn--2RygE";
export var dropdownContent = "Navbar-module--dropdown-content--JEhLq";
export var navlinks_container = "Navbar-module--navlinks_container--1plIp";
export var links_wrapper = "Navbar-module--links_wrapper--fOEou";
export var link_item = "Navbar-module--link_item--aksw9";
export var linkItem = "Navbar-module--link-item--1QHkf";
export var mobile__link_item = "Navbar-module--mobile__link_item--2PEID";
export var toggle_button = "Navbar-module--toggle_button--1nDXs";
export var mobile__navlinks_container = "Navbar-module--mobile__navlinks_container--2-ufm";
export var mobile__links_wrapper = "Navbar-module--mobile__links_wrapper--J6lTO";